import "../../App.css";
import React, { useState, useRef, useEffect } from "react";
import ImageScroller, { defaultStatus } from "react-image-scroller";
import smoothscroll from "smoothscroll-polyfill";
import classNames from "classnames";

import CardText from "../../components/CardText";
import CardImg from "../../components/CardImg";
import CardTextIcon from "../../components/CardTextIcon";
import Footer from "../../components/Footer";

import logo from "../../assets/logo.png";
import Logo2 from "../../assets/logo.svg";

import Number1 from "../../assets/number1.svg";
import Number2 from "../../assets/number2.svg";
import Number3 from "../../assets/number3.svg";
import Number4 from "../../assets/number4.svg";
import S1 from "../../assets/sponsor/1.svg";
import S2 from "../../assets/sponsor/2.svg";
import S3 from "../../assets/sponsor/3.svg";
import S4 from "../../assets/sponsor/4.svg";
import S5 from "../../assets/sponsor/5.svg";
import S6 from "../../assets/sponsor/6.svg";
import S7 from "../../assets/sponsor/7.svg";
import S8 from "../../assets/sponsor/8.svg";
import S9 from "../../assets/sponsor/9.svg";
import S10 from "../../assets/sponsor/10.svg";
import S11 from "../../assets/sponsor/11.svg";
import BG1 from "../../assets/bg1.svg";
import BG2 from "../../assets/bg2.svg";
import BG3 from "../../assets/bg3.svg";
import BG4 from "../../assets/bg4.svg";
import BG5 from "../../assets/bg5.svg";
import Card1 from "../../assets/card1.svg";
import Card2 from "../../assets/card2.svg";
import Card3 from "../../assets/card3.svg";
import Arrow1 from "../../assets/arrow1.svg";
import Arrow2 from "../../assets/arrow2.svg";
import NImg1 from "../../assets/newImg1.svg";
import NImg2 from "../../assets/newImg2.svg";
import NImg3 from "../../assets/newImg3.svg";
import NImg4 from "../../assets/newImg4.svg";
import NImg5 from "../../assets/newImg5.svg";
import IconCard1 from "../../assets/iconCard1.svg";
import IconCard2 from "../../assets/iconCard2.svg";
import IconCard3 from "../../assets/iconCard3.svg";
import IconCard4 from "../../assets/iconCard4.svg";
import IconCard5 from "../../assets/iconCard5.svg";
import imgCard1 from "../../assets/imgCard1.svg";
import imgCard2 from "../../assets/imgCard2.svg";

import { useTranslation } from "react-i18next";

const OtherPage = () => {
  const { t, i18n } = useTranslation();
  function openUrl() {
    window.open("https://bit.ly/csrsubmit", "_blank");
  }
  const images = [
    <img className="" src={S1} alt="" />,
    <img className="" src={S2} alt="" />,
    <img className="" src={S3} alt="" />,
    <img className="" src={S4} alt="" />,
    <img className="" src={S5} alt="" />,
    <img className="" src={S6} alt="" />,
    <img className="" src={S7} alt="" />,
    <img className="" src={S8} alt="" />,
    <img className="" src={S9} alt="" />,
    <img className="" src={S10} alt="" />,
    <img className="" src={S11} alt="" />,
  ];
  function FancyScroller() {
    const [showScrollbar, setShowScrollbar] = useState(false);
    const [useThinScrollbar, setUseThinScrollbar] = useState(false);
    const [showIndexButtons, setShowIndexButtons] = useState(false);
    const [status, setStatus] = useState(false);

    return (
      <div>
        <div className="image-gallery w-3/5 m-auto flex">
          <ImageScroller
            style={{}}
            onChange={(newStatus) => setStatus(newStatus)}
            renderWithin={({ scrollTo, next, previous, items, status }) => (
              <div className="flex lg:m-auto lg:mx-60 " style={{ marginTop: '24px' }}>
                <div className="lg:w-full sm:w-full sm:invisible lg:visible">
                  <button
                    style={{
                      color: " #FF9086",
                    }}
                    onClick={previous}
                    className="nav-button nav-button--previous "
                    aria-label="Next"
                  >
                    <span
                      style={{
                        fontSize: "128px",
                      }}
                    >
                      &lsaquo;
                    </span>
                  </button>
                </div>

                <button
                  style={{
                    color: " #FF9086",
                  }}
                  onClick={next}
                  disabled={status.next === null}
                  className="nav-button nav-button--next"
                  aria-label="Next"
                >
                  <span
                    style={{
                      fontSize: "128px",
                    }}
                  >
                    &rsaquo;
                  </span>
                </button>
              </div>
            )}
          >
            {images.map((item, itemIndex) => (
              <div
                key={itemIndex}
                className={classNames({
                  "image-wrapper": true,
                  "image-wrapper--scrollbar": showScrollbar,
                })}
              >
                <div
                  style={{
                    borderRadius: "10px",
                    width: "180px",
                    height: "100px",
                    background: "#FFFFFF",
                    boxShadow: "0px 6px 7px rgba(219, 0, 144, 0.2)",
                  }}
                  className="flex justify-center mx-5  px-5"
                >
                  {item}
                </div>
              </div>
            ))}
          </ImageScroller>
        </div>
      </div>
    );
  }

  useEffect(() => {
    setTimeout(() => {
      document
        .getElementsByClassName('image-gallery')[0]
        .children[0]
        .children[0]
        .style
        .overflowX = 'hidden';
    }, 1e3);
  });

  return (
    <div className="flex flex-col w-full">
      <div
        className="w-full justify-center"
        style={{ minWidth: "1440px" }}
      ></div>

      <div
        style={{
          width: "1440px",
          paddingBottom: "",
          background: "#FFFFFF",
        }}
        className="flex flex-col m-auto sm:text-4xl "
      >
        <div className="flex sm:justify-center lg:justify-start">
          <img className="py-5 lg:ml-40 lg:w-32 sm:w-1/4" src={Logo2} alt="" />
        </div>
        <div
          className="-mr-80 right-0 -mr-10 sm:invisible lg:visible"
          style={{
            position: "absolute",
            width: "789px",
            height: "789px",
          }}
        >
          <img src={BG1} alt="" />
        </div>
        <div className="lg:mx-40 lg:items-center flex lg:flex-row sm:flex-col lg:text-end sm:items-end ">
          <div className="lg:w-1/2 flex flex-col lg:text-left">
            <div className="flex sm:justify-center lg:justify-start sm:mt-10 lg:font-semibold lg:text-5xl lg:leading-10 lg:items-center ">
              <p
                style={{
                  
                  fontStyle: "normal",
                  color: "#26355C",
                }}
                className="lg:leading-tight"
              >
                {t("title1")}
              </p>
            </div>
            <div className="">
              <p
                style={{
                  
                  fontStyle: "normal",
                  alignItems: "center",
                  fontWeight: "normal",
                  color: "#696969",
                  fontSize: "25px",
                }}
                className="lg:mt-10"
              >
                {t("desc1")}
              </p>
            </div>
            <div className="sm:flex sm:justify-center lg:justify-start lg:mt-0 sm:mt-10">
              <button
                onClick={() => openUrl()}
                style={{
                  color: "white",
                  background:
                    "linear-gradient(89.97deg, #F06E00 0.03%, #DB0090 99.98%)",
                  borderRadius: "35px",
                  paddingTop: '0.8em',
                  paddingBottom: '0.8em',
                }}
                className="  lg:py-2  lg:mt-5 lg:w-1/2 sm:text-lg"
              >
                {t("button1")}
              </button>
            </div>
          </div>
          <div className="lg:ml-20 sm:flex sm:m-auto">
            <img className="sm:w-10/12 lg:w-full sm:mt-10" src={NImg1} alt="" />
          </div>
        </div>
        <div className="lg:mt-20">
          <div
            style={{
              position: "absolute",
              width: "789px",
              height: "789px",
            }}
          >
            <img src={BG2} alt="" />
          </div>
          <p
            className="lg:mb-10 m-auto p-5 lg:text-1xl font-semibold leading-relaxed text-center text-blue-800 lg:pb-4 lg:text-3xl lg:pl-0 lg:font-bold lg:text-center">
            {t("trusted")}
          </p>
          <FancyScroller />
        </div>
        <div
          className="lg:mt-40 sm:mt-20 text-center"
          style={{ color: "#26355C" }}
        >
          <p
            style={{
              
              fontStyle: "normal",
              color: "#26355C",
              lineHeight: "64px"
            }}
            className="m-auto sm:text-5xl lg:w-3/2 lg:font-semibold lg:text-5xl leading-10"
          >
            {t("middleTitleLine1")}
            <br/>
            {t("middleTitleLine2")}
          </p>
          <p
            style={{
              
              fontStyle: "normal",
              fontWeight: "normal",
              lineHeight: "40px",
              color: "#696969",
            }}
            className="m-auto lg:w-full lg:mt-10 sm:mt-5 lg:font-semibold lg:text-2xl  lg:leading-10"
          >
            {t("middleDesc")}
          </p>
          <div className="flex flex-row lg:gap-2 mt-10 justify-center">
            <div
              className="lg:-mr-20 lg:right-0 sm:invisible lg:visible lg:-mt-64 sm:mr-2"
              style={{
                position: "absolute",
                width: "789px",
                height: "789px",
              }}
            >
              <img src={BG3} alt="" />
            </div>
            <img src={Card1} alt="" />
            <img src={Arrow2} alt="" />
            <img src={Card2} alt="" />
            <img src={Arrow2} alt="" />
            <img src={Card3} alt="" />
          </div>
        </div>
        <div
          className="lg:mt-40 sm:mt-20 text-center"
          style={{ color: "#26355C" }}
        >
          <p
            style={{
              
              fontStyle: "normal",
              color: "#26355C",
            }}
            className="m-auto sm:text-5xl lg:w-1/2 lg:font-semibold lg:text-5xl lg:leading-10 "
          >
            {t("middleTitle2")}
          </p>
          <p
            style={{
              
              fontStyle: "normal",
              fontWeight: "normal",
              lineHeight: "40px",
              color: "#696969",
            }}
            className="m-auto lg:w-3/4 lg:px-20  lg:mt-10 sm:mt-5 lg:font-semibold lg:text-2xl  lg:leading-10 "
          >
            {t("middleDesc2")}
          </p>
        </div>

        <div className="lg:mx-40 sm:mt-20 lg:mt-20 lg:items-center flex lg:flex-row sm:flex-col lg:text-end sm:items-end ">
          <div
            className="lg:-ml-40"
            style={{
              position: "absolute",
              width: "589px",
              height: "589px",
            }}
          >
            <img src={BG4} alt="" />
          </div>
          <div className="lg:w-1/2  flex flex-col lg:text-left">
            <div className="flex sm:justify-center lg:justify-start sm:mt-10 lg:font-semibold lg:text-2xl lg:leading-10 lg:items-center ">
              <p
                style={{
                  
                  fontStyle: "normal",
                  color: "#26355C",
                }}
                className="lg:leading-tight lg:pr-20 z-40 "
              >
                {t("title2")}
              </p>
            </div>
            <div className="sm:flex sm:text-center lg:text-left lg:justify-start sm:mt-5 lg:mx-0 sm:mx-20 lg:relative lg:text-xl lg:leading-0 lg:items-center">
              <p
                style={{
                  
                  fontStyle: "normal",
                  alignItems: "center",
                  fontWeight: "normal",
                  lineHeight: "27px",
                  color: "#696969",
                }}
                className="z-40"
              >
                {t("desc2")}
              </p>
            </div>
            <div
              className="-mt-10 "
              style={{
                position: "absolute",
                width: "789px",
                height: "789px",
              }}
            >
              <img className="z-10 sm:m-auto lg:m-0" src={Number1} alt="" />
            </div>
          </div>
          <div className="lg:ml-20 sm:flex sm:m-auto">
            <img className="sm:w-10/12 lg:w-full sm:mt-10" src={NImg2} alt="" />
          </div>
        </div>

        <div className="lg:mx-40 sm:mt-20 lg:mt-20 lg:items-center flex lg:flex-row-reverse sm:flex-col lg:text-end sm:items-end ">
          <div className="lg:ml-20 lg:w-1/2  flex flex-col lg:text-left">
            <div className="flex sm:justify-center lg:justify-start sm:mt-10 lg:font-semibold lg:text-2xl lg:leading-10 lg:items-center ">
              <p
                style={{
                  
                  fontStyle: "normal",
                  color: "#26355C",
                }}
                className="lg:leading-tight lg:pr-20 z-40 "
              >
                {t("title3")}
              </p>
            </div>
            <div className="sm:flex sm:text-center lg:text-left lg:justify-start sm:mt-5 lg:mx-0 sm:mx-20 lg:relative lg:text-xl lg:leading-0 lg:items-center">
              <p
                style={{
                  
                  fontStyle: "normal",
                  alignItems: "center",
                  fontWeight: "normal",
                  lineHeight: "27px",
                  color: "#696969",
                }}
                className="z-40"
              >
                {t("desc3")}
              </p>
            </div>
            <div
              className="-mt-10 lg:right-0 lg:-mr-40"
              style={{
                position: "absolute",
                width: "789px",
                height: "789px",
              }}
            >
              <img className="z-10 sm:m-auto lg:m-0" src={Number2} style={{ margin: 'auto' }} alt="" />
            </div>
          </div>
          <div className=" sm:flex sm:m-auto">
            <img className="sm:w-10/12 lg:w-full sm:mt-10" src={NImg3} alt="" />
          </div>
        </div>

        <div className="lg:mx-40 sm:mt-20 lg:mt-20 lg:items-center flex lg:flex-row sm:flex-col lg:text-end sm:items-end ">
          <div className="lg:w-3/4  flex flex-col lg:text-left">
            <div className="flex sm:justify-center lg:justify-start sm:mt-10 lg:font-semibold lg:text-2xl lg:leading-10 lg:items-center ">
              <p
                style={{
                  
                  fontStyle: "normal",
                  color: "#26355C",
                }}
                className="lg:leading-tight lg:pr-20 z-40 "
              >
                {t("title4")}
              </p>
            </div>
            <div className="sm:flex sm:text-center lg:text-left lg:justify-start sm:mt-5 lg:mx-0 sm:mx-20 lg:relative lg:text-xl  lg:items-center">
              <p
                style={{
                  
                  fontStyle: "normal",
                  alignItems: "center",
                  fontWeight: "normal",
                  lineHeight: "27px",
                  color: "#696969",
                }}
                className="z-40"
              >
                {t("desc4")}
              </p>
            </div>
            <div
              className="-mt-20 "
              style={{
                position: "absolute",
                width: "789px",
                height: "789px",
              }}
            >
              <img className="z-10 sm:m-auto lg:m-0" src={Number3} alt="" />
            </div>
          </div>
          <div className="lg:ml-20 sm:flex sm:m-auto">
            <img className="sm:w-10/12 lg:w-full sm:mt-10" src={NImg4} alt="" />
          </div>
        </div>

        <div className="lg:mx-40 sm:mt-20 lg:mt-20 lg:items-center flex lg:flex-row-reverse sm:flex-col lg:text-end sm:items-end ">
          <div
            className=" lg:-mt-80 lg:right-0 sm:invisible lg:visible  sm:mr-2"
            style={{
              position: "absolute",
              width: "789px",
              height: "789px",
            }}
          >
            <img src={BG5} alt="" />
          </div>
          <div className="lg:ml-20 lg:w-1/2  flex flex-col lg:text-left">
            <div className="flex sm:justify-center lg:justify-start sm:mt-10 lg:font-semibold lg:text-2xl lg:leading-10 lg:items-center ">
              <p
                style={{
                  
                  fontStyle: "normal",
                  color: "#26355C",
                }}
                className="lg:leading-tight lg:pr-20 z-40 "
              >
                {t("title5")}
              </p>
            </div>
            <div className="sm:flex sm:text-center lg:text-left lg:justify-start sm:mt-5 lg:mx-0 sm:mx-20 lg:relative lg:text-xl lg:leading-0 lg:items-center">
              <p
                style={{
                  
                  fontStyle: "normal",
                  alignItems: "center",
                  fontWeight: "normal",
                  lineHeight: "27px",
                  color: "#696969",
                }}
                className="z-40"
              >
                {t("desc5")}
              </p>
            </div>
            <div
              className="-mt-10 lg:right-0 lg:-mr-48"
              style={{
                position: "absolute",
                width: "789px",
                height: "789px",
              }}
            >
              <img className="z-10 sm:m-auto lg:m-0" src={Number4}  style={{ margin: 'auto' }} alt="" />
            </div>
          </div>
          <div className=" sm:flex sm:m-auto">
            <img className="sm:w-10/12 lg:w-full sm:mt-10" src={NImg5} alt="" />
          </div>
        </div>

        <div
          className="lg:mt-20 sm:mt-20 text-center"
          style={{ color: "#26355C" }}
        >
          <p
            style={{
              
              fontStyle: "normal",
              color: "#26355C",
            }}
            className="m-auto sm:text-2xl lg:w-1/2 lg:font-semibold lg:text-3xl "
          >
            {t("middleTitle3")}
          </p>
          <p
            style={{
              
              fontStyle: "normal",
              fontWeight: "normal",
              lineHeight: "40px",
              color: "#696969",
            }}
            className="m-auto lg:w-3/4 lg:px-20  sm:mt-5 lg:mt-1 lg:font-semibold lg:text-2xl  "
          >
            {t("middleTitle4")}
          </p>
        </div>
        <div className="flex flex-col mt-10 m-auto">
          <div
            className="lg:mt-40"
            style={{
              position: "absolute",
              width: "589px",
              height: "589px",
            }}
          >
            <img src={BG4} alt="" />
          </div>
          <div className="flex flex-row">
            <CardText
              primaryTitle={t("cardText1")}
              secondaryTitle={t("cardTitle1")}
              description={t("cardSubTitle1")}
              icon={IconCard1}
              />
            <CardText
              primaryTitle={t("cardText2")}
              secondaryTitle={t("cardTitle2")}
              description={t("cardSubTitle2")}
              icon={IconCard2}
              />
          </div>
          <div className="flex flex-row">
            <CardText
              primaryTitle={t("cardText3")}
              secondaryTitle={t("cardTitle3")}
              description={t("cardSubTitle3")}
              icon={IconCard3}
              />
            <CardText
              primaryTitle={t("cardText4")}
              secondaryTitle={t("cardTitle4")}
              description={t("cardSubTitle4")}
              icon={IconCard4}
              />
          </div>
          <div className="flex flex-row">
            <CardText
              primaryTitle={t("cardText5")}
              secondaryTitle={t("cardTitle5")}
              description={t("cardSubTitle5")}
              icon={IconCard5}
              />
          </div>
        </div>
        <div
          className="lg:mt-20 sm:mt-20 text-center"
          style={{ color: "#26355C" }}
        >
          <p
            style={{
              
              fontStyle: "normal",
              color: "#26355C",
            }}
            className="m-auto sm:text-2xl lg:w-3/4 lg:font-semibold lg:text-3xl "
          >
            {t("middleTitle5")}
          </p>
          <div
            className="  lg:-mt-60 lg:right-0 sm:invisible lg:visible  sm:mr-2"
            style={{
              position: "absolute",
              width: "789px",
              height: "789px",
            }}
          >
            <img src={BG5} alt="" />
          </div>
        </div>

        <div className="flex flex-row gap-10 pb-40 justify-center m-auto  w-full">
          <CardImg
            title={t("cardImgTitle1")}
            subtitle={t("cardImgSubTitle1")}
            img={imgCard1}
            onClickButton={() => openUrl()}
            buttonText={t("cardImgButtonText")}
          />
          <CardImg
            title={t("cardImgTitle2")}
            subtitle={t("cardImgSubTitle2")}
            img={imgCard2}
            onClickButton={() => openUrl()}
            buttonText={t("cardImgButtonText")}
          />
        </div>
      </div>
      <div
        className="lg:mt-1 lg:w-full sm:w-full sm:text-4xl sm:px-20 p-8"
        style={{
          background: "linear-gradient(92.57deg, #F06E00 0%, #DB0090 100%)",
        }}
      >
        <p className="m-auto text-white leading-10 lg:text-4xl text-center text-blue-800 lg:pb-4 lg:text-center">
          {t("footerText")}
        </p>
        <div className="flex justify-center  ">
          <button
            onClick={() => openUrl()}
            style={{
              color: "black",
              background: "white",
              borderRadius: "35px",
            }}
            className=" sm:text-2xl text-gray-100 mb-10 py-2 lg:px-14 lg:text-sm sm:p-2 lg:mt-10 sm:px-4"
          >
            {t("buttonFooter")}
          </button>
        </div>
      </div>
      <Footer logo={logo} />
    </div>
  );
};

export default OtherPage;
